import { Box, MenuItem, Select, Tab, Tabs, TextField } from '@mui/material';
import ChannelModalityIcon from 'components/@home/@settings/Tabs/Agents/instructionEditor/ChannelModalityIcon';
import { func, number, oneOf } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

export const ChannelTabs = ({ channel, onChange }) => (
  <Tabs
    sx={{
      minHeight: 0,
      mb: 2,
      borderBottom: 1,
      borderColor: 'divider',
    }}
    value={channel}
    onChange={(_, v) => onChange(v)}
    textColor="primary"
    indicatorColor="primary"
  >
    <Tab
      sx={{
        minHeight: 40,
        minWidth: 0,
        textTransform: 'none',
        fontSize: theme => theme.typography.pxToRem(13),
        fontWeight: 500,
        gap: 0.75,
        '& .MuiTab-iconWrapper': {
          mb: 0,
          mr: 0.75,
          width: 16,
          height: 16,
          minWidth: 16,
          overflow: 'visible',
        },
      }}
      value="voice"
      icon={<ChannelModalityIcon modality="voice" size={16} />}
      iconPosition="start"
      label={I18n.t('AgenticChatFlow.TimeoutChannelVoice')}
    />
    <Tab
      sx={{
        minHeight: 40,
        minWidth: 0,
        textTransform: 'none',
        fontSize: theme => theme.typography.pxToRem(13),
        fontWeight: 500,
        gap: 0.75,
        '& .MuiTab-iconWrapper': {
          mb: 0,
          mr: 0.75,
          width: 16,
          height: 16,
          minWidth: 16,
          overflow: 'visible',
        },
      }}
      value="chat"
      icon={<ChannelModalityIcon modality="text" size={16} />}
      iconPosition="start"
      label={I18n.t('AgenticChatFlow.TimeoutChannelChat')}
    />
  </Tabs>
);
ChannelTabs.propTypes = { channel: oneOf(['voice', 'chat']).isRequired, onChange: func.isRequired };

export const DurationField = ({ seconds, unit, onChangeSeconds, onChangeUnit }) => {
  const shown = unit === 'minutes' ? Math.round((seconds || 0) / 60) : seconds || 0;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField
        sx={{ width: 120 }}
        size="small"
        type="number"
        value={shown}
        onChange={e => {
          const n = e.target.value === '' ? 0 : Number(e.target.value);
          onChangeSeconds(unit === 'minutes' ? n * 60 : n);
        }}
      />
      <Select
        sx={{ width: 120 }}
        size="small"
        value={unit}
        onChange={e => onChangeUnit(e.target.value)}
      >
        <MenuItem value="minutes">{I18n.t('AgenticChatFlow.TimeoutUnitMinutes')}</MenuItem>
        <MenuItem value="seconds">{I18n.t('AgenticChatFlow.TimeoutUnitSeconds')}</MenuItem>
      </Select>
    </Box>
  );
};
DurationField.propTypes = {
  seconds: number,
  unit: oneOf(['minutes', 'seconds']).isRequired,
  onChangeSeconds: func.isRequired,
  onChangeUnit: func.isRequired,
};

export default ChannelTabs;
